module.exports = __webpack_public_path__ + "static/media/2018_0718_18562300-01.7ad2c674.jpg";